// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'trial-balance.page.create.title': 'Import Trial Balances',
    'trial-balance-csv.page.import.title': 'Import Trial Balances',
    'trial-balance-csv.button.import': 'Import',

    'trial-balance.button.cancel': 'Cancel',
    'trial-balance.button.save': 'Import',
    'trial-balance.button.add': 'Add Entry',
    'trial-balance.button.create': 'New Entry',

    'trial-balance.link.create_first_trial_balance': 'Click here to import your first trial balance',
    'trial-balance.link.retry': 'Click here to retry',

    'trial-balance.label.debit': 'Debit',
    'trial-balance.label.credit': 'Credit',
    'trial-balance.label.trial_balance_batch_name': 'Trial Balance Batch',
    'trial-balance.label.general_ledger_account': 'General Ledger Account',
    'trial-balance.label.entity_name': 'Contact',
    'trial-balance.label.trial_balance_date': 'Entry Date',
    'trial-balance.label.memo': 'Memo',

    'trial-balance.success.message.trial_balance_created': 'Please check your email for the import status',

    'trial-balance.error.message.unbalanced': 'Total Debits must equal Total Credits',
    'trial-balance.error.message.error_loading_page': 'Sorry, there was an error loading trial balance.| Sorry, there was an error loading trial balances.',

    'trial-balance-csv.page.note': 'Please ensure to click the check mark if your file already includes headers.',

    'trial-balance-csv.button.download': 'Download Sample File',
    'trial-balance-csv.page.sample_file': 'Trial Balance Sample File',
    'trial-balance-csv.page.message.column_names': 'Column names are in the first line',
    'trial-balance-csv.page.message.field': 'Field',
    'trial-balance-csv.page.message.column': 'Column',

    'trial-balance-csv.error.message.csv_is_blank': "It looks like the CSV file is empty. No worries — just take a moment to double-check your file, and feel free to try again whenever you're ready!",
    'trial-balance-csv.page.instructions': 'Below is a sample file which will show the fields used in the import process.',

    'trial-balance-csv.error.message.invalid_file_type': 'Sorry, we only support CSV files. Please try again with a CSV file.',
};
